import { render, staticRenderFns } from "./CafeMenuItem.vue?vue&type=template&id=eda985fc&"
import script from "./CafeMenuItem.vue?vue&type=script&lang=js&"
export * from "./CafeMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('eda985fc', component.options)
    } else {
      api.reload('eda985fc', component.options)
    }
    module.hot.accept("./CafeMenuItem.vue?vue&type=template&id=eda985fc&", function () {
      api.rerender('eda985fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/common/CafeMenuItem.vue"
export default component.exports